import { render, staticRenderFns } from "./newAcg.vue?vue&type=template&id=29f52f2f&scoped=true&"
import script from "./newAcg.vue?vue&type=script&lang=js&"
export * from "./newAcg.vue?vue&type=script&lang=js&"
import style0 from "./newAcg.vue?vue&type=style&index=0&id=29f52f2f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29f52f2f",
  null
  
)

export default component.exports